import useSentinelTeam from 'hooks/useSentinelTeam';
import { useLocation, Navigate } from 'react-router-dom';

import ROUTE_NAMES from 'setup/Routing/routeNames';
import { useCurrentUserContext } from 'utils/User';

type Props = {
  children: React.ReactNode;
};

export default function NonOemGroupManagerRoute({ children }: Props) {
  const location = useLocation();
  const { isSuperUser } = useCurrentUserContext();
  const { oemSegment, belongsToOemSegment } = useSentinelTeam();

  const partialAdminAccess = oemSegment?.settings?.partialAdminAccess ?? false;

  const shouldRedirect =
    !isSuperUser && belongsToOemSegment && partialAdminAccess;

  if (shouldRedirect) {
    return (
      <Navigate
        to={ROUTE_NAMES.access_denied}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}
